let audioContext = null;
let pending = false;
let listening = false;

const gestureEvents = ['pointerdown', 'keydown'];

function contextConstructor() {
  if (typeof window === 'undefined') return null;
  return window.AudioContext || window.webkitAudioContext;
}

function removeGestureListeners() {
  if (!listening || typeof window === 'undefined') return;
  gestureEvents.forEach((event) => window.removeEventListener(event, handleGesture));
  listening = false;
}

function ensureGestureListeners() {
  if (listening || typeof window === 'undefined') return;
  gestureEvents.forEach((event) => window.addEventListener(event, handleGesture, { once: true }));
  listening = true;
}

function tone(context, frequency, startAt, duration) {
  const oscillator = context.createOscillator();
  const gain = context.createGain();
  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(frequency, startAt);
  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(0.12, startAt + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
  oscillator.connect(gain);
  gain.connect(context.destination);
  oscillator.start(startAt);
  oscillator.stop(startAt + duration + 0.01);
}

async function play() {
  const AudioContextType = contextConstructor();
  if (!AudioContextType) return false;
  try {
    audioContext ||= new AudioContextType();
    if (audioContext.state === 'suspended') await audioContext.resume();
    if (audioContext.state !== 'running') return false;
    const now = audioContext.currentTime;
    tone(audioContext, 660, now, 0.13);
    tone(audioContext, 880, now + 0.15, 0.16);
    return true;
  } catch (_) {
    return false;
  }
}

async function handleGesture() {
  removeGestureListeners();
  if (!pending) return;
  pending = false;
  if (!(await play())) {
    pending = true;
    ensureGestureListeners();
  }
}

async function notify() {
  const hasActivation = typeof navigator === 'undefined'
    || navigator.userActivation?.hasBeenActive !== false;
  if (hasActivation && await play()) {
    pending = false;
    removeGestureListeners();
    return true;
  }
  pending = true;
  ensureGestureListeners();
  return false;
}

function reset() {
  pending = false;
  removeGestureListeners();
}

export const requestAlertSound = { notify, reset };
